import * as moment from "moment";
import { defineComponent } from "vue";
import ChatAdminPollForm from "./ChatAdminPollForm";

export default defineComponent({
    components: {
        ChatAdminPollForm,
    },

    template: `
        <div class="ChatAdminFooter">
            <button type="button" class="button button--1" @click="show_blocked = !show_blocked">Zablokowani ({{ admininfo.banned.length }})</button>
            <button type="button" class="button button--1" @click="show_poll = !show_poll">Nowe głosowanie</button>

            <div v-if="show_blocked && admininfo.banned.length" class="ChatAdminFooter__blocked">
                Odblokuj:
                <ul>
                    <li v-for="user in admininfo.banned" >
                        <button type="button" @click="onUnblock(user)">#{{ user.id }} {{ user.name }} (do {{ formatDate(user.date) }})</button>
                    </li>
                </ul>
            </div>

            <div v-if="show_blocked && admininfo.banned.length" class="ChatAdminFooter__blocked">
                Odblokuj:
                <ul>
                    <li v-for="user in admininfo.banned" >
                        <button type="button" @click="onUnblock(user)">#{{ user.id }} {{ user.name }} (do {{ formatDate(user.date) }})</button>
                    </li>
                </ul>
            </div>

            <ChatAdminPollForm v-if="show_poll" @close="show_poll = false" />
        </div>
    `,

    emits: [
    ],

    props: {
        admininfo: { type: Object, required: true },
    },

    data() {
        return {
            show_blocked: false,
            show_poll: false,
        };
    },

    methods: {
        async onUnblock(user: any) {
            await this.$root.socket.emit('user-ban', {
                userid: user.id,
                ban: false,
            });
        },

        formatDate(date: Date) {
            return moment(date).format('YYYY-MM-DD hh:mm');
        },
    },
});
